import * as tslib_1 from "tslib";
var BaseApiClient = /** @class */ (function () {
    function BaseApiClient(configuration, ajaxService) {
        this.ajaxService = ajaxService;
        this.configuration = configuration;
    }
    /**
     * Prepare URL and options for AJAX request
     * @param request
     */
    BaseApiClient.prototype.getFetchOptions = function (request) {
        var localVarRequestOptions = Object.assign({ method: 'POST' });
        var localVarHeaderParameter = {};
        localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
        localVarHeaderParameter['Authorization'] = this.configuration.accessToken;
        localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter);
        localVarRequestOptions.body = JSON.stringify(request || {});
        return localVarRequestOptions;
    };
    /**
     * Execute AJAX request to BFF
     * @param url BFF endpoint
     * @param request Request object to be send
     */
    BaseApiClient.prototype.executeRequest = function (url, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fetchUrl, options, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchUrl = this.configuration.basePath + url;
                        options = this.getFetchOptions(request);
                        return [4 /*yield*/, this.ajaxService.send(fetchUrl, options)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status >= 200 && response.status < 300)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw response;
                }
            });
        });
    };
    BaseApiClient.prototype.refreshToken = function (token) {
        this.configuration.accessToken = token;
    };
    return BaseApiClient;
}());
export { BaseApiClient };
;
//# sourceMappingURL=BaseApiClient.js.map